import React, { Component } from 'react'
import '../styles/MainScreenMobile.css'

import KindredLogo from '../../assets/kp png logo.svg';
import SpeakerLeft from '../../assets/Speaker Left.svg';
import SpeakerRight from '../../assets/Speaker Right.svg';
import ArrowLeft from '../../assets/Arrow Left.svg';
import ArrowRight from '../../assets/Arrow Right.svg';
import ArrowDown from '../../assets/Arrow Down 2.svg';

export default class MainScreen extends Component {

  state = this.props.parentState;

  render() {
    return (
      <div className = "mobile-horizontal-flex-container">

				<div className="speakers-mobile">
					<img src={SpeakerLeft} className="left" />
					<img src={SpeakerRight} className="right" />
				</div>

        <div className = "logo-container">
            <img src = {KindredLogo} className = "logo" />
            <div className = "company-name">
							{this.props.companyName}
            </div>

						<div className="slogan">
							{this.props.sloganText}
            </div>
        </div>

        <div className = "navigation-container">
					<div className = "left-right-arrow-container">
						<div className="left-arrow-container" onClick={this.props.leftAction}>
							Services
							<img src = {ArrowLeft} className = "left-arrow-img"/>
						</div>
						<div className="right-arrow-container" onClick={this.props.rightAction}>
							Portfolio
							<img src={ArrowRight} className="right-arrow-img" />
						</div>
					</div>

					<div className="bottom-arrow-container">
						<div className="bottom-arrow-inner-container" onClick={this.props.downAction}>
							Meet the Team
							<img src={ArrowDown} className="down-arrow-img" />
						</div>
					</div>
        </div>
      </div>
    )
  }
}
